<div class="star-rating-container container" fxLayout="row" fxLayoutAlign="space-between" [matTooltip]="tooltip">
  <fa-icon icon="star" [ngStyle]="{'font-size': size + 'px', 'line-height': size + 'px'}"
           *ngFor="let i of countArray(fullStars)"></fa-icon>
  <fa-icon icon="star-half-alt" [ngStyle]="{'font-size': size + 'px', 'line-height': size + 'px'}"
           *ngFor="let i of countArray(halfStars)"></fa-icon>
  <fa-icon [icon]="['far', 'star']" [ngStyle]="{'font-size': size + 'px', 'line-height': size + 'px'}"
           *ngFor="let i of countArray(emptyStars)"></fa-icon>
</div>
